<template>
  <v-app id="inspire" app>
    <banner
      :user="user"
      :currentRoute="$router.currentRoute.name"
      @openDrawer="openDrawer"
      @openDialogLogin="openDialogLogin"
      @onClickLogout="onClickLogout"
    />

    <navigation
      :drawer="drawer"
      :currentRoute="$router.currentRoute.name"
      @openDrawer="openDrawer"
    />

    <v-main>
        <router-view />
    </v-main>
    <content-info />
    <modal-login
      :dialog.sync="modaLogin"
      @onClickLogin="onClickLogin"
      @closeDialog="closeDialogLogin"
    />
    <modal-pump ref="modalPump" />
    <v-dialog
      :persistent="isReady && (isReady.message && !isReady.message.includes('404'))"
      v-model="isReady"
      max-width="400"
    >
      <v-card>

        <v-card-title class="headline" v-if="isReady && isReady.message.includes('404')">
          {{ isReady.name }}
        </v-card-title>
        <v-card-text v-if="isReady && isReady.message.includes('404')">
          <p>{{ isReady.message }}</p>
          <p class="font-weight-bold mb-0">{{ isReady.name }}: {{ isReady.message }}</p>
        </v-card-text>

        <v-card-title class="headline" v-if="isReady && !isReady.message.includes('404')">
          {{$t('window.error.disconnect.title')}}
        </v-card-title>
        <v-card-text v-if="isReady && !isReady.message.includes('404')">
          <p>{{$t('window.error.disconnect.content')}}</p>
          <p class="font-weight-bold mb-0">{{ isReady.name }}: {{ isReady.message }}</p>
        </v-card-text>

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="isReady = null">{{$t('theme.close')}}</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { mapGetters } from 'vuex'
// import TransitionPage from '@/components/transitions/TransitionPage'
export default {
  name: 'App',
  data () {
    return {
      errors: null,
      drawer: false,
      modaErrors: null,
      modaLogin: null
    }
  },

  components: {
    // TransitionPage,
    Banner: () => import(/* webpackChunkName: "Banner" */ '@/components/layout/Banner'),
    Navigation: () => import(/* webpackChunkName: "Navigation" */ '@/components/layout/Navigation'),
    ContentInfo: () => import(/* webpackChunkName: "ContentInfo" */ '@/components/layout/Contentinfo'),
    ModalLogin: () => import(/* webpackChunkName: "ModalLogin" */ '@/modules/auth/ModalLogin'),
    ModalPump: () => import(/* webpackChunkName: "ModalPump" */ '@/modules/pumps/PumpModal'),
  },

  computed: {
    ...mapGetters("auth", [
      "user",
    ]),

    isReady () {
      const errorsTerms = this.$store.getters["home/termsError"]
      const errorsAuth = this.$store.getters["auth/status"]
      // console.log(errorsTerms, errorsAuth)
      if (errorsTerms || errorsAuth) {
        const errors = { ...errorsTerms, ...errorsAuth }
        // this.modaErrors = true
        // this.errors = errors
        return errors
      }
      return null
    }
  },

  created () {
    this.$root._i18n._vm.locale = this.user.language.toLowerCase()
    this.$router.beforeEach((to, from, next) => {
      this.modaLogin = false
      this.$root.$children[0].$refs.modalPump.closeDialog()
      next();
    });
  },

  methods: {

    openDrawer ($event = null) {
      if ($event) {
        this.drawer = $event
      } else {
        this.drawer = !this.drawer
      }
    },

    openDialogLogin () {
      this.drawer = false
      this.modaLogin = true
    },

    closeDialogLogin () {
      this.drawer = false
      this.modaLogin = false
    },

    onClickLogin (login) {
      this.$store.dispatch('auth/login', login)
        .then (() => {
          this.modaLogin = false
          this.$router.go(0)
        })
        .catch (() => {
          this.$router.go(0)
        })
    },

    onClickLogout () {
      this.$store.dispatch('auth/logout')
        .then (() => {
          this.$router.go(0)
        })
        .catch (() => {
          this.$router.go(0)
        })
    }
  }
}
</script>
<style>

@media (max-width: 540px) {
  html {
    font-size: 80%;
  }
}
@media (max-width: 1263px) {
  .container {
    width: 100%;
    max-width: 1185px;
  }
}
hr {
  color: #fff;
  background: #fff;
  border-color: rgba(0,92,170,.15);
  border-style: solid;
  border-width: 1px;
}
.w-100 {
  width: 100% !important;
}
.h-100 {
  height: 100% !important;
}
.img-fluid {
  height: auto;
  max-width: 100%;
}
.bg-grey-light {
  background: #fbfbfb;
}
.v-expansion-panel:before {
  content: "";
  display: none;
}
.theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:before {
  background: #085fa9;
}

.v-row-title span {
  margin-left: .5rem;
  display: flex;
  flex-direction: column;
  line-height: 1;
}
.v-row-title small {
  font-weight: normal;
  font-size: 60%;
}
.nprogress-busy .v-sheet {
  z-index: 9999 !important;
}
.nprogress-busy #nprogress .bar {
  top: 64px !important;
}
.v-application .v-btn--outlined {
  background: #fff;
}

.searchBox {
  position: relative;
  align-items: center;
  display: flex;
}

.jumbotron {
  position: relative;
  width: 100%;
}
.jumbotron:before {
  content: "";
  background: rgba(8, 95, 169, 0.75);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
}
.jumbotron-background {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
}
.jumbotron .container {
  position: relative;
  z-index: 4;
}
.jumbotron .relative {
  position: relative;
}
@media (min-width: 600px) {
  .jumbotron-newProduct .relative img {
    position: absolute;
    top: -205px;
  }
}

/**
 *
 * Headband styles
 */

.v-menu__content .fileLanguages {
  margin-bottom: 0 !important;
  font-size: 100%;
}
.v-menu__content .v-text-field__details {
  display: none;
}
.headsearch a,
.headsearch a:hover,
.headsearch a:focus {
  color: #fff !important;
} 
.v-list-item__icon {
  align-self: center !important;
}
.v-select__slot {
  margin-left: .25rem !important;
}
.v-select-list .v-list-item__icon {
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 8px!important;
}
.v-select-list .v-list-item {
  min-height: 32px!important;
  font-size: 80%;
}

.chipSector {
  color: #fff;
  margin: 5px 5px 5px 0;
  padding: 4px 5px;
  border-radius: 5px;
  font-size: 95%;
}

.v-navigation-drawer {
  z-index: 91 !important;
}

.v-navigation-drawer__content .searchBox {
  min-width: auto !important;
}

.v-navigation-drawer .theme--light.v-subheader a {
  color: rgba(0,0,0,.6);
}
.v-navigation-drawer .theme--light.v-subheader a:hover,
.v-navigation-drawer .theme--light.v-subheader a:focus {
  text-decoration: none;
}

/**
 *
 * Document styles
 */
.v-card__title {
  line-height: 1.5;
  font-size: 115%;
}
.v-card__title span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-card__title small {
  font-size: 60%;
  display: flex;
}
.card-capture {
  padding: 1.5em;
  position: relative;
  background: rgba(204, 204, 204, .5);
}
.card-capture .fa {
  font-size: 175%;
}
.card-picture {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
  background: #ccc;
  color: #fff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
}
.card-family {
  position: absolute;
  bottom: .25em;
  right: .5em;
}

.bg-al { background: #ffa400 !important; }
.bg-gl { background: #007600 !important; }
.bg-wl { background: #1489ca !important; }
.bg-il { background: #9568aa !important; }
.bg-fl { background: #787c7f !important; }

.opa-al { background: rgba(255, 164, 0, .25) !important; }
.opa-gl { background: rgba(0, 118, 0, .25) !important; }
.opa-wl { background: rgba(20, 137, 202, .25) !important; }
.opa-il { background: rgba(149, 104, 170, .25) !important; }
.opa-fl { background: rgba(120, 124, 127, .25) !important; }
</style>
